module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "select-wrapper"
  }, [_c('span', [_vm._v("Camera")]), _vm._v(" "), _vm._l((_vm.videoDevices), function(device) {
    return _c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedDevice),
        expression: "selectedDevice"
      }],
      attrs: {
        "disabled": _vm.sharingScreenOnly,
        "name": "video-device",
        "type": "radio"
      },
      domProps: {
        "value": device.deviceId,
        "checked": _vm._q(_vm.selectedDevice, device.deviceId)
      },
      on: {
        "change": _vm.onChange,
        "__c": function($event) {
          _vm.selectedDevice = device.deviceId
        }
      }
    }), _vm._v("\n        " + _vm._s(device.label) + "\n    ")])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-265371a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoDeviceSelect.vue
// module id = 363
// module chunks = 1